const typeOptions = [
	{ key: 1, text: "Menú", value: "menu" },
	{ key: 2, text: "Link", value: "link" },
	{ key: 3, text: "Divider", value: "divider" },
];

export default typeOptions;

export const ACTION_TYPE_OPTIONS = [
	{ key: "internal", value: "internal", text: "Internal" },
	{ key: "external", value: "external", text: "External" },
];

export const HTTP_METHOD_OPTIONS = [
	{ key: "get", value: "GET", text: "GET" },
	{ key: "post", value: "POST", text: "POST" },
	{ key: "put", value: "PUT", text: "PUT" },
	{ key: "patch", value: "PATCH", text: "PATCH" },
	{ key: "delete", value: "DELETE", text: "DELETE" },
];
